/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:d52c1fe0-a63f-4e5d-a9a1-85e2d56818ec",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_9WAwslIVs",
    "aws_user_pools_web_client_id": "2l35ja0suamv8g94jiasmb71ii",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "tiendahubapi",
            "endpoint": "https://ehzh51syi5.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        },
        {
            "name": "tiendapagosapi",
            "endpoint": "https://53h2waw14l.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        },
        {
            "name": "tiendalogger",
            "endpoint": "https://xf1aa5m5a4.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        }
    ]
};


export default awsmobile;
